var map = {
	"./additional/machineCategories/store": "cbc7",
	"./additional/machines/store": "e4bd",
	"./additional/messages/store": "c794",
	"./additional/operators/store": "4e10",
	"./additional/substrates/store": "e2b3",
	"./baskets/store": "e249",
	"./jobs/store": "25ad",
	"./notifications/store": "1d1e",
	"./settings/digitalSettings/store": "7ac3",
	"./settings/printProviders/store": "0818",
	"./statistics/store": "b08e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc18";